export default function getActionClauseTypeOptions() {
    //******** MUST READ ********//
    // Must keep in order by dropdown section!
    return [
        // Organize
        'moveTo',
        'copyTo',
        'delete',
        'pin',
        // Mark message
        'read',
        'junk',
        'markImportance',
        'category',
        // Route
        'forwardTo',
        'forwardAsAttachmentTo',
        'redirectTo',
    ];
}
//# sourceMappingURL=getActionClauseTypeOptions.js.map